<div *ngIf="currStep$ | async as currStep">
  <ng-container *ngFor="let step of steps$ | async">
    <ib-sign-up-step-objective
      *ngIf="step.type === STEPS.OBJECTIVE && currStep.type === STEPS.OBJECTIVE"
      class="block"
      [@detailExpand]
      [form]="step.form"
    >
    </ib-sign-up-step-objective>
    <ib-sign-up-step-start
      *ngIf="step.type === STEPS.START && currStep.type === STEPS.START"
      class="block"
      [@detailExpand]
      [form]="step.form"
    >
    </ib-sign-up-step-start>
    <ib-sign-up-step-address
      *ngIf="step.type === STEPS.ADDRESS && currStep.type === STEPS.ADDRESS"
      class="block"
      [@detailExpand]
      [form]="step.form"
    >
    </ib-sign-up-step-address>
    <ib-sign-up-step-docs
      *ngIf="step.type === STEPS.DOCS && currStep.type === STEPS.DOCS"
      class="block"
      [@detailExpand]
      [isActive]="currStep.type === STEPS.DOCS"
      [form]="step.form"
    >
    </ib-sign-up-step-docs>
    <ib-sign-up-step-finish
      *ngIf="step.type === STEPS.FINISH && currStep.type === STEPS.FINISH"
      class="block"
      [@detailExpand]
      [form]="step.form"
    >
    </ib-sign-up-step-finish>
  </ng-container>
</div>
<!-- <div *ngIf="currStep$ | async as currStep">
  <ng-container *ngFor="let step of steps$ | async">
    <ib-sign-up-step-objective
      *ngIf="step.type === STEPS.OBJECTIVE"
      class="block"
      [@detailExpand]
      [form]="step.form"
    >
    </ib-sign-up-step-objective>
    <ib-sign-up-step-start
      *ngIf="step.type === STEPS.START"
      class="block"
      [@detailExpand]
      [form]="step.form"
    >
    </ib-sign-up-step-start>
    <ib-sign-up-step-address
      *ngIf="step.type === STEPS.ADDRESS"
      class="block"
      [@detailExpand]
      [form]="step.form"
    >
    </ib-sign-up-step-address>
    <ib-sign-up-step-docs
      *ngIf="step.type === STEPS.DOCS"
      class="block"
      [@detailExpand]
      [isActive]="currStep.type === STEPS.DOCS"
      [form]="step.form"
    >
    </ib-sign-up-step-docs>
    <ib-sign-up-step-finish
      *ngIf="step.type === STEPS.FINISH"
      class="block"
      [@detailExpand]
      [form]="step.form"
    >
    </ib-sign-up-step-finish>
  </ng-container>
</div> -->
